import { createSlice } from "@reduxjs/toolkit";
import { reKyc_UpdateBankThunk, reKyc_UploadDocumentsRekycThunk } from "./thunk";

export const initialState = {
  reKyc_UploadDocumentsRekycData: [],
  reKyc_UploadDocumentsRekycError: "", // for error message
  reKyc_UploadDocumentsRekycLoading: false,
};

const Re_Kyc_UploadDocumentsRekyc = createSlice({
  name: "Re_Kyc_UploadDocumentsRekyc",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reKyc_UploadDocumentsRekycThunk.pending, (state) => {
      state.reKyc_UploadDocumentsRekycLoading = true;
      state.reKyc_UploadDocumentsRekycData = [];
      state.reKyc_UploadDocumentsRekycError = "";
    });
    builder.addCase(reKyc_UploadDocumentsRekycThunk.fulfilled, (state, action) => {
      state.reKyc_UploadDocumentsRekycData = action.payload.data;
      state.reKyc_UploadDocumentsRekycLoading = false;
    });
    builder.addCase(reKyc_UploadDocumentsRekycThunk.rejected, (state, action) => {
      state.reKyc_UploadDocumentsRekycError =
        action.error?.message ||
        action.payload?.message ||
        "An unknown error occurred";
      state.reKyc_UploadDocumentsRekycLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Re_Kyc_UploadDocumentsRekyc.actions;

export default Re_Kyc_UploadDocumentsRekyc.reducer;
